module.exports = __webpack_public_path__ + "static/media/share-icon.a8e13ff6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share-icon.svg
// module id = 831
// module chunks = 0